import React, { useEffect, useRef, useState } from "react";

function SegmentDropDown(props) {
  const [segmentShow, setSegmentShow] = useState(false);
  const [segmentId, setSegmentId] = useState([]);
  const [segmentName, setSegmentName] = useState([]);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setSegmentShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  function forUpdateSegmentChild(data) {
    let segmentFromID = [];
    let segmentFromName = [];
    for (let item of data) {
      if (item.segId) {
        segmentFromID.push(parseInt(item.segId));
      }
      if (item.segName) {
        segmentFromName.push(item.segName);
      }
    }
    setSegmentId(segmentFromID);
    setSegmentName(segmentFromName);
    defaultSegmentSet();
  }

  const handleSegmentCheck = (e) => {
    if (e.target.checked === true) {
      if (!segmentName.includes(e.target.name)) {
        setSegmentName([...segmentName, e.target.name]);
        setSegmentId([...segmentId, parseInt(e.target.value)]);
      }
    } else {
      if (segmentName.includes(e.target.name)) {
        let segmentNameArray = [...segmentName];
        let segmentIdArray = [...segmentId];
        let i = segmentName.indexOf(e.target.name);
        let j = segmentId.indexOf(parseInt(e.target.value));
        segmentNameArray.splice(i, 1);
        segmentIdArray.splice(j, 1);
        setSegmentName(segmentNameArray);
        setSegmentId(segmentIdArray);
      }
    }
  };

  useEffect(() => {
    document.querySelector("#Input_Segment").value = segmentName.join(",");
  }, [segmentName]);

  useEffect(() => {
    if (segmentShow) {
      defaultSegmentSet();
    }
  }, [segmentShow, segmentId]);

  const defaultSegmentSet = () => {
    let selectAllCheckbox = document.querySelector("#select-all");
    if (selectAllCheckbox) {
      if (segmentId.length === 5) {
        selectAllCheckbox.checked = true;
      } else {
        selectAllCheckbox.checked = false;
      }
    }
    let deafultSegment = [...segmentId];
    deafultSegment.forEach((item) => {
      let element = document.getElementById(`segId-${item}`);
      // let elementProps = propsId;
      if (element) {
        element.checked = true;
      }
    });
  };
  props.forSegement(segmentId);
  const returnSegmentID = () => {
    setSegmentId([]);
    setSegmentName([]);
    setSegmentShow(false);
  };
  const closeSegmentDropdown = () => {
    setSegmentShow(false);
  };
  props.hiRef.returnSegmentID = returnSegmentID;
  props.hiRef.forUpdateSegmentChild = forUpdateSegmentChild;
  props.hiRef.closeSegmentDropdown = closeSegmentDropdown;

  const handleAllCheckSegment = (e) => {
    if (e.target.checked === true) {
      if (!segmentName.includes(e.target.value)) {
        setSegmentName(props.segmentValue.map((item) => item.segName));
        setSegmentId(props.segmentValue.map((item) => item.segId));
      }
    } else {
      segmentId.forEach((item) => {
        let element = document.getElementById(`segId-${item}`);
        // let elementProps = propsId;
        if (element) {
          element.checked = false;
        }
      });
      setSegmentName([]);
      setSegmentId([]);
    }
  };

  return (
    <div className="rm-custom-dropdown" ref={dropdownRef}>
      <input
        type="text"
        name="search-text"
        id="Input_Segment"
        className={`input-st ap cursor-point ${
          props.errorMainSegment ? "invalid" : ""
        }`}
        placeholder="--Select Segment--"
        autoComplete="off"
        readOnly
        onClick={() => {
          setSegmentShow(!segmentShow);
        }}
        disabled={props.bankVeriModal === true || props.getRole !== "FranchiseManager"}
      />
      <button
        type="button"
        className="rm-dropdown-btn"
        onClick={() => {
          setSegmentShow(!segmentShow);
        }}
        disabled={props.bankVeriModal === true || props.getRole !== "FranchiseManager"}
      >
        <span className="icon-right-arrow-triangle"></span>
      </button>
      {segmentShow && (
        <>
          <ul className="rm-mapping-ap apSearch border-0" id="browsers-Rm">
            <li className="rm-maping-item-wrapper">
              <input
                type="checkbox"
                name="select-all"
                className="segmentCheckbox"
                value="select"
                id="select-all"
                onChange={handleAllCheckSegment}
              />
              <label htmlFor="select-all"> </label>
              <span className="for-label">Select All</span>
            </li>
            {props.segmentValue &&
              props.segmentValue.map((item, key) => {
                return (
                  <>
                    <li className="rm-maping-item-wrapper" key={key}>
                      <input
                        type="checkbox"
                        name={item.segName}
                        className="segmentCheckbox"
                        value={item.segId}
                        id={`segId-${item.segId}`}
                        onChange={handleSegmentCheck}
                      />
                      <label htmlFor={`segId-${item.segId}`}> </label>
                      <span className="for-label">{item.segName}</span>
                    </li>
                  </>
                );
              })}
          </ul>
        </>
      )}
    </div>
  );
}

export default SegmentDropDown;
